import { createMuiTheme } from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';

export default createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: [
      'Roboto Condensed',
      'sans-serif',
    ].join(','),
  },
  primaryColor: '#0b214f',
  orangeColor: orange[400],
  boxShadow: '0px 3px 16px #455b6320',
});
